import React, { useContext } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {Button} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { authContext } from '../Context/Authentication/authContext';


const DownloadExcelButton = (props: any) => {
  const {jsonData, type} = props
   const {state}: any = useContext(authContext);
   
   const getDate=()=>{
    if (state.filters.selectedType === 'cityPredictions') {
      return state.filters.predictionFor
    } else if (state?.filters?.selectedType === "zipcodePredictions") {
      return state.filters.zipcodeQuarterPredictionFor
    } else {
      return state.filters.predictionFor
    }

   }
  const downloadExcel = () => {
    const updatedJsonData = jsonData.map((item: any) => ({
      State: state.filters.state || 'N/A', // Add the state column, default to 'N/A' if not provided
      Time_Period: getDate(),
      ...item, // Spread the existing data after the new columns
    }));
    const worksheet = XLSX.utils.json_to_sheet(updatedJsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DataSheet');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xls',
      type: 'array',
    });

    const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.ms-excel' });
    saveAs(excelBlob, `${type || 'file'}.xls`);
  };

  return (
    <Button
      className='excel-button'
      endIcon={<DownloadIcon/>}
      onClick={downloadExcel}
      // disabled={type === ''}
    >
      Download
    </Button>
  );
}

export default DownloadExcelButton;